import type { MenuConfig } from '~typings/menu'

import permisosTributacionPg, { RESOURCE_TRIBUTACION_PG } from '@/auth/permissions/modules/tributacionPg'
import * as names from '@routes/tributacion-pg/nombres/transacciones'

const { transacciones } = permisosTributacionPg
export default [
    {
        title: 'tributacion.subopciones.RDEP',
        resource: RESOURCE_TRIBUTACION_PG,
        action: transacciones.rdep._perm,
        children: [
            {
                title: 'tributacion.subopciones.migrar_excel',
                route: names.ROUTE_MIGRAR_EXCEL_RDEP,
                resource: RESOURCE_TRIBUTACION_PG,
                action: transacciones.rdep.migrarExcelRDEP,
            },
            {
                title: 'tributacion.subopciones.generar_xml',
                route: names.ROUTE_GENERAR_XML_RDEP,
                resource: RESOURCE_TRIBUTACION_PG,
                action: transacciones.rdep.generarXmlRDEP,
            },
        ],
    },
    {
        title: 'tributacion.subopciones.generar_xml_ats',
        route: names.ROUTE_GENERAR_XML_ATS,
        resource: RESOURCE_TRIBUTACION_PG,
        action: transacciones.generarXmlATS,
    },
    {
        title: 'tributacion.subopciones.bandeja_documentos_retencion',
        route: names.ROUTE_BANDEJA_DOCUMENTOS_RETENCION,
        resource: RESOURCE_TRIBUTACION_PG,
        action: transacciones.documentoRetencion,
    },
    {
        title: 'tributacion.subopciones.solicitud_anulacion_doc_electronicos',
        route: names.ROUTE_SOLICITUD_ANULACION_DOCUMENTOS_ELECTRONICOS,
        resource: RESOURCE_TRIBUTACION_PG,
        action: transacciones.solicitudAnulacionDocElectronicos,
    },
] as MenuConfig[]
